import type React from "react";
import { useEffect, useState } from "react";
import { Progress } from "../ui/progress";

export const IndeterminateProgress: React.FC = () => {
	const [value, setValue] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setValue((prev) => (prev >= 100 ? 0 : prev + 1));
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return <Progress value={value} />;
};
